import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
 {
  description: 'Relatório de Baixas Patrimoniais',
  path: '/patrimonio/relatoriobaixa',
  name: 'patrimonio-relatorio-baixa',
  component: () => import('@/views/patrimonio/relatoriobaixa/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.RELATORIOBAIXASNOVO_MENU_1200400299],
  },
  goesToMenu: true,
 },
]
